<div *ngIf="addressFormGroup">
  <div class="form-group">
    <label class="address-lines-header">
      {{ "LABELS.ADDRESS" | translate }}
      <i class="fa fa-asterisk form-required" aria-hidden="true" *ngIf="isShowRequired"></i>
    </label>
  </div>
  <div class="form-row">
    <div class="col-12">
      <app-control-wrapper [control]="addressFormGroup.get('line1')" [errors]="errors.address" [isShowHelper]="false">
        <input
          type="text"
          [formControl]="addressFormGroup.get('line1')"
          class="form-control"
          id="line1"
          name="line1"
          [dropSpecialCharacters]="false"
          [mask]="'F{32}'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          [maxMaskLength]="32"
          [placeholder]="'LABELS.STREET_NUMBER_AND_NAME' | translate"
          [patterns]="CUSTOM_MASK"
          control-wrapper
        />
      </app-control-wrapper>
    </div>
  </div>
  <div class="form-row">
    <div class="col-12">
      <app-control-wrapper [control]="addressFormGroup.get('line2')" [errors]="errors.address" [isShowHelper]="false">
        <input
          type="text"
          [formControl]="addressFormGroup.get('line2')"
          class="form-control"
          id="line2"
          name="line2"
          [dropSpecialCharacters]="false"
          [mask]="'F{32}'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          [maxMaskLength]="32"
          [placeholder]="'LABELS.APARTMENT_OR_UNIT' | translate"
          [patterns]="CUSTOM_MASK"
          control-wrapper
        />
      </app-control-wrapper>
    </div>
  </div>
  <div class="form-row">
    <div class="col-12">
      <app-control-wrapper [control]="addressFormGroup.get('line3')" [errors]="errors.address" [isShowHelper]="false">
        <input
          type="text"
          [formControl]="addressFormGroup.get('line3')"
          class="form-control"
          id="line3"
          name="line3"
          [dropSpecialCharacters]="false"
          [mask]="'F{32}'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          [maxMaskLength]="32"
          [placeholder]="'LABELS.ADDITIONAL_ADDRESS_LINE' | translate"
          [patterns]="CUSTOM_MASK"
          control-wrapper
        />
      </app-control-wrapper>
    </div>
  </div>
</div>
